"use client";

import { useEffect } from "react";
import { applyTheme, currentTheme, isSignedIn, isTheme } from "@/lib/theme";

/**
 * Signed-in users: adopt the theme saved in the database (e.g. first visit on a new device).
 * Does nothing for visitors (no cookie => no request).
 */
export function ThemeSync() {
  useEffect(() => {
    if (!isSignedIn()) return;
    let off = false;
    fetch("/api/theme", { credentials: "same-origin", cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!off && d && isTheme(d.theme) && d.theme !== currentTheme()) applyTheme(d.theme, { animate: false });
      })
      .catch(() => {});
    return () => {
      off = true;
    };
  }, []);
  return null;
}
